const days = ["Vasárnap", "Hétfő", "Kedd", "Szerda", "Csütörtök", "Péntek", "Szombat"];

const months = ["Január", "Február", "Március", "Április", "Május", "Június", "Július", "Augusztus", "Szeptember", "Október", "November", "December"];

const months_short = ["Jan", "Feb", "Márc", "Ápr", "Máj", "Jún", "Júl", "Aug", "Szep", "Okt", "Nov", "Dec"];

function padNumber(value) {
    return String(value).padStart(2, '0');
}

function getValidDate(date) {
    const temp_date = new Date(date);

    if (Number.isNaN(temp_date.getTime())) return null;

    return temp_date;
}

export function formatDateNumeric(date) {
    const temp_date = getValidDate(date);

    if (!temp_date) return "-";

    return `${temp_date.getFullYear()}.${padNumber(temp_date.getMonth() + 1)}.${padNumber(temp_date.getDate())}`;
}

export function formatDateTimeNumeric(date) {
    const temp_date = getValidDate(date);

    if (!temp_date) return "-";

    return `${formatDateNumeric(temp_date)} ${padNumber(temp_date.getHours())}:${padNumber(temp_date.getMinutes())}`;
}

export function formatDate(date, type = "long", backend_format = false) {
    let now = new Date();
    let temp_date = new Date(date);

    let time = temp_date.toLocaleTimeString("hu", {hour: '2-digit', minute:'2-digit'});

    if(backend_format) return `${temp_date.getFullYear()}-${("0" + (temp_date.getMonth() + 1)).slice(-2)}-${("0" + temp_date.getDate()).slice(-2)} ${time}`;

    if(now.toLocaleDateString() === temp_date.toLocaleDateString()) return `Ma ${time}`;

    if(Math.floor((now - temp_date) / (24 * 60 * 60 * 1000)) < 7) return `${days[temp_date.getDay()]} ${time}`;

    if(temp_date.getFullYear() === now.getFullYear()) return `${(type === "long" ? months[temp_date.getMonth()] : `${months_short[temp_date.getMonth()]}.`)} ${("0" + temp_date.getDate()).slice(-2)}. ${time}`

    return `${temp_date.getFullYear()}-${("0" + (temp_date.getMonth() + 1)).slice(-2)}-${("0" + temp_date.getDate()).slice(-2)} ${time}`;
}